export default {
  'en': '英文',
  'tc': '中文',
  'short': {
    'en': '英文',
    'tc': '中文',
  }
}